import get from 'lodash/get';
import isFunction from 'lodash/isFunction';
import { isItemRPSCompound, updateItemRPSCompound, updateGroupRPSCompound } from './RPSUtils';

const getChildren = (routeLayout, item, group) => {
  const { id: itemId } = item;
  const { id: groupId } = group || {};
  // eslint-disable-next-line no-shadow
  return routeLayout && routeLayout.filter(({ parentId, group }) => parentId === itemId && group === groupId);
};

const getTypeFromChildren = (children) => get(children, [0, 'type']); // get from 1st child. All of them should have the same type.

// eslint-disable-next-line import/prefer-default-export
export const buildStepsDataFromRouteLayout = (routeLayout, mapperFunc) => {
  return routeLayout.reduce((memo, item) => {
    const { step, groups, selected, id: itemId, parentId } = item;

    if (groups) {
      groups.forEach((group) => {
        // If groups - get everything from group
        const { id, ...rest } = group;
        const children = getChildren(routeLayout, item, group);
        const stepObj = {
          step: id,
          parentId: itemId,
          type: getTypeFromChildren(children),
          selected,
          ...rest,
          // RPS - update group data if item is RPS compound
          // updateGroupRPSCompound returns only { type, reactionId, databaseId }
          ...(isItemRPSCompound(item) && updateGroupRPSCompound(group, routeLayout)),
        };
        memo.push(isFunction(mapperFunc) ? mapperFunc(stepObj, item, children) : stepObj);
      });
    } else if (step) {
      // If no groups but step:
      // - get confidence / yield from item
      const { confidence, yield: yieldValue } = item;
      const children = getChildren(routeLayout, item);
      const customChild = children && children.find(({ custom, group }) => custom && !group);
      // - examples / reaction from custom child without group (if present) OR from item itself
      const { examples, reaction } = customChild || item;

      const stepObj = {
        step,
        parentId,
        type: getTypeFromChildren(children),
        selected,
        ...reaction, // spread reaction to reactionId, databaseId
        ...(examples && { examples }),
        ...(confidence && { confidence }),
        ...(yieldValue && { yield: yieldValue }),
      };

      // RPS - update step data if item is RPS compound
      // updateItemRPSCompound returns only { type, reaction: { reactionId, databaseId } }
      if (isItemRPSCompound(item)) {
        const rpsUpdatedItem = updateItemRPSCompound(item);
        Object.assign(stepObj, {
          type: rpsUpdatedItem.type,
          reactionId: rpsUpdatedItem.reaction?.reactionId,
          databaseId: rpsUpdatedItem.reaction?.databaseId,
        });
      }

      memo.push(isFunction(mapperFunc) ? mapperFunc(stepObj, item, children) : stepObj);
    }

    return memo;
  }, []);
};
